/** @jsx jsx */
import { jsx, css } from "@emotion/core";

const nav = css`
  font-family: "Merienda One", serif;
  margin-top: 20px;

  a,
  span {
    font-size: 1.25rem;
    margin: 0 6px;
    cursor: pointer;
  }

  section {
    max-width: 800px;
    margin: 0 auto;
  }
`;

export default () => (
  <nav css={nav}>
    <section>
    </section>
  </nav>
);
